<template>
	<div class="pricelist">
		<b-overlay :show="loading" rounded="sm">
			<b-card header-tag="header" footer-tag="footer">
				<div slot="header" class="top-card">
					<div class="d-flex justify-content-center align-items-center">
						<h5 class="mb-0" style="white-space: nowrap">{{
							$t('prices.radioButtons.pricingItemsWithDifferentPrices') }}</h5>
					</div>
				</div>
				<b-table class="generalTableClass" hover="hover" striped="striped" bordered="bordered" small="small"
					fixed="fixed" :items="items.items" responsive="sm" :fields="fieldsForPricingItems" show-empty>
					<!-- EMPTY SLOT FOR TABLE -->
					<template slot="empty" slot-scope="scope">
						<h4>{{ $t('empty') }}</h4>
					</template>
					<template slot="id" slot-scope="data">
						<strong>{{ data.item.id }}</strong>
					</template>
					<template slot="costDate" slot-scope="data">
						<strong>{{ data.item.costDate }}</strong>
					</template>
					<template slot="costNumber" slot-scope="data">
						<strong>{{ data.item.costNumber }}</strong>
					</template>
					<template slot="companies" slot-scope="data">
						<div v-for="(company, index) in data.item.companies">
							<strong>{{ index + 1 }}. </strong>
							<strong>{{ company.name }}</strong>
						</div>
					</template>
					<template slot="comment" slot-scope="data">
						<strong>{{ data.item.comment }}</strong>
					</template>
					<template slot="actions" slot-scope="data">
						<b-link v-if="data.item.pricingStatus == 'SUSPENDED'" variant="outline"
							@click.prevent="editPrice(data.item.id, data.item.byExcel)">
							<i class="fa fa-pencil"></i>
						</b-link>
					</template>
					<template slot="number" slot-scope="data">
						<strong>{{ paginate(data.index, payload.page, payload.limit) }}</strong>
					</template>
					<template slot="details" slot-scope="data">
						{{ data.item.name }}
					</template>
					<template slot="barcode" slot-scope="data">
						{{ data.item.barcode }}
					</template>
					<template slot="multiBarcode" slot-scope="data">
						<div v-for="(i, index) in data.item.multiBarcodes">
							{{ i }}<br>
						</div>
					</template>
					<template slot="incomeUzs" slot-scope="data">
						<span v-if="data.item.incomeUzs > 0">
							{{ data.item.incomeUzs | currency({
								symbol: '', fractionCount: 2, symbolPosition: 'back',
								thousandsSeparator: ' '
}) }}
						</span>
						<span v-else></span>
					</template>
					<template slot="extraCosts" slot-scope="data">
						<span>{{ data.item.extraCosts | currency({
							symbol: '', fractionCount: 2, symbolPosition: 'back',
							thousandsSeparator: ' '
}) }}</span>
					</template>
					<template slot="paid" slot-scope="data">
						<span v-if="data.item.paid == true"><span style="color: green">Pretul este dat</span></span>
						<span v-else><span style="color: orange">Prețul nu este dat</span></span>
					</template>
					<template slot="uzb" slot-scope="data">
						<span v-if="data.item.priceUzs > 0">
							{{ data.item.priceUzs | currency({
								symbol: '', fractionCount: 2, symbolPosition: 'back',
								thousandsSeparator: ' '
}) }}
						</span>
						<span v-else></span>
					</template>
					<template slot="lastPriceWholesale" slot-scope="data">
						<span v-if="data.item.priceWholesale > 0">
							{{ data.item.priceWholesale | currency({
								symbol: '', fractionCount: 2, symbolPosition: 'back',
								thousandsSeparator: ' '
}) }}
						</span>
						<span v-else></span>
					</template>
				</b-table>
				<nav>
					<b-pagination size="sm" :total-rows="items.total" :per-page="payload.limit" v-model="payload.page"
						:prev-text="$t('pagination.prev')" :next-text="$t('pagination.next')" hide-goto-end-buttons />
					<download-excel v-if="downloadItems.length > 0" :data="downloadItems" :fields="json_to_excel"
						:disabled="loading" style="cursor: pointer" class="btn btn-outline-primary float-right"
						name="Товары с разными ценами">
						<b-spinner v-if="loading" small
							class="mr-2" /><strong>{{ $t('excel-export.download-excel') }}</strong>
					</download-excel>
				</nav>
			</b-card>
		</b-overlay>
	</div>
</template>

<script>
import PricesService from "../../services/prices.service";
import { BOverlay } from 'bootstrapVue2';

export default {
	name: "ItemWithDifferentPrices",
	components: { BOverlay },
	data() {
		return {
			items: [],
			payload: {
				page: 1,
				limit: 20,
				departmentIds: []
			},
			loading: false,
			downloadItems: [],
			json_to_excel: {
				'СпецКод': 'barcode',
				'Наименование': 'name',
				'Штрих-код': 'multiBarcodeString',
				'прод.цена в UZS за ед-цу': 'priceUzs'
			}
		}
	},
	watch: {
		'payload.page': {
			handler(p) {
				this.getItems();
			}
		}
	},
	computed: {
		fieldsForPricingItems() {
			return [
				{
					key: 'number',
					label: '№',
					sortable: true
				},
				{
					key: 'barcode',
					label: this.$t('goods.special-barcode'),
				},
				{
					key: 'details',
					label: this.$t('prices.item.details'),
				},
				{
					key: 'multiBarcode',
					label: this.$t('goods.barcode'),
				},
				{
					key: 'uzb',
					label: this.$t('prices.item.lastPriceUzs'),
				}
			]
		}
	},
	methods: {
		async getItems() {
			this.loading = true
			await PricesService.pricingItemsWithPaginationSection3(this.payload).then(res => {
				this.items = res.data
			})
			if (this.downloadItems.length === 0) {
				await PricesService.getPricingItemsWithDifferent().then(res => {
					this.downloadItems = res.data.items
				})
			}
			this.loading = false
		},
		paginate(index, page_size, page_number) {
			--page_size;
			return (page_number * page_size) + index + 1;
		}
	},
	created() {
		this.getItems();
	}
}
</script>

<style scoped></style>
